<template>
  <div>
    <div class="edit-card" style="margin-top: 20px; padding-bottom: 10px">
      <div style="width: 88%; display: flex">
        <div class="start-label" />
        <span class="text">{{ typeName }}详细信息</span>
      </div>
      <div v-if="canEdit" style="margin: 20px 0 12px 10px">
        <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
        <el-button class="btn" size="small" type="danger" plain :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
      </div>
      <div v-else style="margin-top: 20px"></div>
      <el-table ref="childTable" stripe border :data="dataArray" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" :header-cell-style="{ background: '#DDEBFF' }">
        <el-table-column v-if="canEdit" show-overflow-tooltip type="selection" fixed width="50" align="center" />
        <el-table-column show-overflow-tooltip label="资产编号" align="center" min-width="140" prop="fixedAssetNo" />
        <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="130" prop="fixedAssetName" />
        <el-table-column label="资产卡号" align="center" min-width="200" prop="fixedAssetCards">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
              <div slot="content" class="">
                <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                  {{ item.no }}
                </div>
              </div>
              <span class="td-overflow-hidden">{{
                scope.row.assetCardInfos
                  ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                  : ""
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="130" prop="specName" />
        <!-- <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" /> -->
        <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" />
        <el-table-column show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" />
        <el-table-column show-overflow-tooltip label="生产厂家" align="center" min-width="130" prop="manufacturerName" />
        <el-table-column show-overflow-tooltip label="供应商" align="center" min-width="130" prop="supplierName" />
        <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
        <el-table-column show-overflow-tooltip label="产地类型" align="center" min-width="80" prop="productionPlaceName" />
        <el-table-column show-overflow-tooltip label="财务分类" align="center" min-width="80" prop="financeTypeName" />
        <template v-if="isPurchase">
          <el-table-column show-overflow-tooltip label="剩余库存" align="center" min-width="120" prop="stockNumber" :formatter="toDecimal2" />
        </template>
        <el-table-column v-if="isInventory" show-overflow-tooltip label="库存数量" align="center" min-width="120" prop="number" :formatter="toDecimal2" />
        <el-table-column v-else-if="!isWorkOrder" show-overflow-tooltip :label="typeName + '数量'" align="center" :min-width="typeName.length > 2 ? 160 : 80" prop="number" :formatter="toDecimal2" />
        <template v-if="isPurchase">
          <el-table-column show-overflow-tooltip label="预计单价" align="center" min-width="120" prop="price" :formatter="toDecimal4" />
        </template>
        <template v-else>
          <el-table-column show-overflow-tooltip label="单价" align="center" min-width="120" prop="price" :formatter="toDecimal4" />
        </template>
        <el-table-column v-if="!isWorkOrder" show-overflow-tooltip label="金额" align="center" min-width="120" prop="amount" :formatter="toDecimal4" />
        <!-- 盘点额外信息 -->
        <template v-if="isInventory">
          <el-table-column show-overflow-tooltip label="库房" align="center" min-width="80" prop="warehouseName" />
          <el-table-column show-overflow-tooltip label="科室" align="center" min-width="80" prop="deptName" />
          <el-table-column show-overflow-tooltip label="盘点数量" align="center" min-width="120" prop="inventoryNumber" :formatter="toDecimal2" />
          <el-table-column show-overflow-tooltip label="盈亏数量" align="center" min-width="120" prop="diffNumber" :formatter="toDecimal2" />
          <el-table-column show-overflow-tooltip label="盈亏金额" align="center" min-width="120" prop="diffAmount" :formatter="toDecimal4" />
          <el-table-column show-overflow-tooltip label="盘点状态" align="center" min-width="80" prop="result" />
          <el-table-column label="盘亏资产卡号" align="center" min-width="200" prop="fixedAssetCards">
            <template slot="header">
              <span>盘亏资产卡号</span>
              <el-tooltip class="item" effect="dark" content="当盘亏资产为建卡资产时，选择相关资产卡号；不做选择，默认为未建卡资产。" placement="top">
                <i class="el-icon-question" style="
                    color: #fff;
                    background-color: #d3d0d3;
                    border-radius: 8px;
                    font-size: 16px;
                  "></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                <div slot="content" class="">
                  <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                    {{ item.no }}
                  </div>
                </div>
                <span class="td-overflow-hidden">{{
                  scope.row.assetCardInfos
                    ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                    : ""
                }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="备注" align="center" min-width="100" prop="remark" />
        </template>
        <!-- 工单管理额外信息 -->
        <template v-if="isWorkOrder">
          <el-table-column label="科室/库房" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.deptName">{{ scope.row.deptName }}</span>
              <span v-else>{{ scope.row.warehouseName }}</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="存放地点/货位" align="center" min-width="120" prop="locationName" />
          <el-table-column v-if="!isMetering" show-overflow-tooltip :min-width="WorkOrderAmountName.length > 2 ? 240 : 120" :label="WorkOrderAmountName + '费用'" align="center" prop="fees" :formatter="toDecimal4" />
        </template>
        <template v-if="isMetering && false">
          <el-table-column show-overflow-tooltip :min-width="WorkOrderAmountName.length > 2 ? 240 : 120" :label="WorkOrderAmountName + '费用'" align="center" prop="fees" :formatter="toDecimal4">
          </el-table-column>
          <el-table-column label="计量合格" align="center" width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.isOk == 0">否</span>
              <span v-else>是</span>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="计量结果" align="center" min-width="120" prop="result" />
          <el-table-column label="附件" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover placement="bottom" width="360" trigger="click">
                <ul class="fileListUl_always">
                  <li class="fileItem" v-for="(item, index) in scope.row.fileInfos" :key="index">
                    <span class="fileName">{{ item.name }}</span>
                    <div class="btn_group" :class="!canEdit ? 'canedit' : ''">
                      <span v-preventReClick @click="privewImg(item)">
                        点击查看
                      </span>
                      <span v-preventReClick @click="downloadImg(item)">
                        下载
                      </span>
                      <!-- <span v-show="canEdit" v-preventReClick
            @click="RemoveFile(item)">
                        删除
                      </span> -->
                    </div>
                  </li>
                </ul>
                <span slot="reference" class="show-files">
                  查看附件
                  <i class="el-icon-caret-top"></i>
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="备注" align="center" min-width="120" prop="remark" />
        </template>
        <!-- 扩展列 -->
        <template v-for="item in moreColumn">
          <slot v-if="item.slot" :name="item.slot">
            <el-table-column v-bind="item"></el-table-column>
          </slot>
          <slot v-else>
            <el-table-column :key="item.param" :align="item.align" :label="item.label" :prop="item.param" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="showOverflowTooltip" :width="item.width"></el-table-column>
          </slot>
        </template>
      </el-table>
    </div>

    <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" ref="childForm" :model="childForm" :rules="childFormRules">
        <el-row>
          <template v-if="showDimension">
            <el-col :span="6">
              <el-form-item label="库存维度" prop="stockRange">
                <el-select :disabled="!canEdit" v-model="childForm.stockRange" style="width: 100%" filterable clearable placeholder="请选择库存维度" @change="stocktakingRangeChange">
                  <el-option v-for="item in InventoryRangeOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="stockDeptName" label="维度详情" v-if="childForm.stockRange == 1">
                <!-- 科室 -->
                <el-select :disabled="!canEdit" v-model="childForm.stockDeptName" style="width: 100%" filterable clearable placeholder="请选择维度详情" :filter-method="getDepts" @change="wdDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="fixedAssetTypeName" label="维度详情" v-else-if="childForm.stockRange == 2">
                <!-- 资产类型 -->
                <template>
                  <SelectTree :disabled="!canEdit" @handleCheckChange="wdAssetTypeChange" :filterable="true" :filterMethod="getAssetTrees" :defaultProps="defaultProps" :placeholder="'请选择维度详情'" :data="STATIC_FixedAssetTrees" :defaultValue="childForm.fixedAssetTypeName" style="width: 100%"></SelectTree>
                </template>
              </el-form-item>
              <el-form-item prop="warehouseName" label="维度详情" v-else>
                <!-- 库房 -->
                <template>
                  <el-select clearable :disabled="!canEdit" v-model="childForm.warehouseName" style="width: 100%" filterable placeholder="请选择维度详情" :filter-method="getWarehouses" @change="WdWarehouseChange">
                    <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="6">
            <el-form-item label="资产编号" prop="fixedAssetNo">
              <SelectTable :disabled="!canEdit" :columns="stockColumns" :placeholder="'请选择资产编号'" :innerName="childForm.fixedAssetNo" :dataList="isNoneAsset ? STATIC_NoneAssets : STATIC_Stocks" @filterMethod="getFixedAssetList" @change="selectAsset" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="资产名称" prop="fixedAssetName">
              <el-input disabled v-model="childForm.fixedAssetName" placeholder="请填写资产名称" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="资产卡号" :prop="isWorkOrder || mustCard ? 'assetCardNoArr' : ''" v-if="!isInventory">
              <el-select :disabled="!canEdit" v-model="childForm.assetCardNoArr" placeholder="请选择资产卡号" :multiple="assetCardMultiple" collapse-tags :filter-method="getAssetCards" @change="cardChange" style="width: 100%">
                <el-option v-for="item in STATIC_AssetCards" :key="item.id" :label="item.no" :value="item.no"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="规格型号" prop="specName">
              <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col> -->
          <el-col :span="6">
            <el-form-item label="品牌" prop="brandName">
              <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="资产类型" prop="assetTypeName">
              <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
            </el-form-item>
          </el-col>
          <template v-if="isPurchase">
            <el-col :span="6">
              <el-form-item label="库存数量" prop="stockNumber">
                <el-input-number disabled v-model="childForm.stockNumber" :min="0" :precision="2" :controls="false" placeholder="系统自动带出库存数量" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="6">
            <el-form-item label="库存数量" prop="number" v-if="isInventory">
              <el-input-number disabled v-model="childForm.number" :min="0" :precision="2" :controls="false" placeholder="系统自动带出库存数量" @change="childNumberChange" style="width: 100%"></el-input-number>
            </el-form-item>
            <el-form-item label="数量" prop="number" v-else-if="!isWorkOrder">
              <el-input-number :disabled="!canEdit || mustCard" v-model="childForm.number" :min="mustCard ? childForm.maxNum : 0" :precision="2" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <template v-if="isPurchase">
            <el-col :span="6">
              <el-form-item label="预计单价" prop="price">
                <el-input-number :disabled="!canEdit" v-model="childForm.price" :min="0" :precision="4" :controls="false" placeholder="请填写单价" style="width: 100%" @change="autoAmount"></el-input-number>
              </el-form-item>
            </el-col>
          </template>
          <template v-else>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input-number disabled v-model="childForm.price" :min="0" :precision="4" :controls="false" placeholder="请填写单价" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="6" v-if="!isWorkOrder">
            <el-form-item label="金额" prop="amount">
              <el-input-number disabled v-model="childForm.amount" :min="0" :precision="4" :controls="false" placeholder="请填写金额" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="货位" prop="locationName">
              <el-input disabled v-model="childForm.locationName" placeholder="系统自动带出货位" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产地类型" prop="productionPlaceName">
              <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="生产厂家" prop="manufacturerName">
              <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商" prop="supplierName">
              <el-input disabled v-model="childForm.supplierName" placeholder="系统自动带出供应商" />
            </el-form-item>
          </el-col>
          <template v-if="isInventory">
            <el-col :span="6">
              <el-form-item label="库房" prop="warehouseName">
                <el-select disabled v-model="childForm.warehouseName" style="width: 100%" filterable placeholder="系统自动带出库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="科室" prop="deptName">
                <el-select disabled v-model="childForm.deptName" style="width: 100%" filterable placeholder="系统自动带出科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点数量" prop="inventoryNumber">
                <el-input-number :disabled="!canEdit" v-model="childForm.inventoryNumber" :min="0" :precision="0" :controls="false" placeholder="请填写盘点数量" style="width: 100%" @change="inventoryNumberChange"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盈亏数量" prop="diffNumber">
                <el-input-number disabled v-model="childForm.diffNumber" :precision="0" :controls="false" placeholder="请填写盘点数量" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盈亏金额" prop="diffAmount">
                <el-input-number disabled v-model="childForm.diffAmount" :precision="4" :controls="false" placeholder="请填写盘点数量" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘点状态" prop="result">
                <el-input disabled v-model="childForm.result" placeholder="系统自动带出盘点状态" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="盘亏资产卡号" prop="assetCardNoArr">
                <el-select :disabled="childForm.result != '盘亏'" v-model="childForm.assetCardNoArr" placeholder="请选择盘亏资产卡号" multiple collapse-tags :filter-method="getAssetCards" @change="cardChange" style="width: 100%">
                  <el-option v-for="item in STATIC_AssetCards" :key="item.id" :label="item.no" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="isWorkOrder && !isMetering">
            <el-col :span="6">
              <el-form-item :label="WorkOrderAmountName + '费用'" prop="fees">
                <el-input-number :disabled="!canEdit" v-model="childForm.fees" :min="0" :precision="4" :controls="false" :placeholder="'请填写' + WorkOrderAmountName + '费用'" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="isMetering && false">
            <el-col :span="6">
              <el-form-item label="计量合格" prop="isOk">
                <el-select :disabled="!canEdit" v-model="childForm.isOk" placeholder="请选择计量合格" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="计量结果" prop="result">
                <el-input :disabled="!canEdit" v-model="childForm.result" placeholder="请填写计量结果" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="上传附件" prop="fileInfos"> </el-form-item>
              <UploadFileList :fileList="childForm.fileInfos" btnShowType="always" :canEdit="canEdit" :showLabel="false" :showFileList="showFileList" ref="UploadFileList" @fileChange="fileChange"></UploadFileList>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!canEdit" v-model="childForm.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <template v-if="isInventory">
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!canEdit" v-model="childForm.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button v-if="canEdit" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
        <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectTable from "@/components/select-table";
import SelectTree from "@/components/select-tree";
import UploadFileList from "@/components/upload-file-list";
import ElImageViewer from "@/components/elImageViewer";
import { InventoryRangeOptions, WhetherOptions } from "@/enum";
export default {
  mixins: [GetDataMixin],
  components: { SelectTable, SelectTree, UploadFileList, ElImageViewer },
  /** 定义属性 */
  data () {
    return {
      // 子表
      childForm: {},
      childFormRules: {},
      childFormRules1: {
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        assetCardNoArr: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
        inventoryNumber: [
          { required: true, message: "盘点数量不能为空", trigger: "blur" },
        ],
        fixedAssetCards: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
      },
      childFormRules2: {
        fixedAssetNo: [
          { required: true, message: "资产编号不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        inventoryNumber: [
          { required: true, message: "盘点数量不能为空", trigger: "blur" },
        ],
        fixedAssetCards: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
      },
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      dataArray: [],
      _FixedAssetParam: this.FixedAssetParam,
      InventoryRangeOptions: InventoryRangeOptions,
      WhetherOptions: WhetherOptions,
      defaultProps: {
        children: "children",
        label: "name",
      },
      filesVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      fileName: "",
      fileId: 0,
    };
  },
  props: {
    typeName: {
      type: String,
      default () {
        return "资产";
      },
    },
    details: {
      type: Array,
      default () {
        return [];
      },
    },
    canEdit: {
      type: Boolean,
      default () {
        return false;
      },
    },
    FixedAssetParam: {
      type: Object,
      default () {
        return {};
      },
    },
    AssetCardsParam: {
      type: Object,
      default () {
        return {
          category: "1",
        };
      },
    },
    ParentForm: {
      type: Object,
      default () {
        return {};
      },
    },
    isPurchase: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isInventory: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isWorkOrder: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isMetering: {
      type: Boolean,
      default () {
        return false;
      },
    },
    showFileList: {
      type: Boolean,
      default () {
        return true;
      },
    },
    WorkOrderAmountName: {
      type: String,
      default () {
        return "资产";
      },
    },
    // 普通列
    moreColumn: {
      type: Array,
      default () {
        return [];
      },
    },
    showDimension: {
      type: Boolean,
      default () {
        return false;
      },
    },
    assetCardMultiple: {
      type: Boolean,
      default () {
        return true;
      },
    },
    isNoneAsset: {
      type: Boolean,
      default () {
        return false;
      },
    },
    mustCard: {
      type: Boolean,
      default () {
        return false;
      },
    },
    isRepeatMsg: {
      type: String,
      default () {
        return "当前资产信息已存在，请去子表编辑！";
      },
    },
    selectAssetMethod: null,
    getFixedAssetListMethod: null,
    getAssetCardsMethod: null,
    deptChangeMethod: null,
    isRepeatMethod: null,
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {
    FixedAssetParam (val) {
      // window.console.log(val);
    },
    canEdit (val) {
      // window.console.log(val);
    },
    isNoneAsset (val) {
      if (val) {
        this.stockColumns = this.defaultNoneStockColumns;
      } else {
        this.stockColumns = this.defaultStockColumns;
      }
    },
  },
  /** 方法集合 */
  methods: {
    setDetalis (data) {
      this.dataArray = data;
    },
    resetDetailFormData () {
      this.childForm = {
        $index: this.dataArray.length + 1,
        assetId: "",
        fixedAssetNo: "",
        fixedAssetName: "",
        specName: "",
        assetCardIds: "",
        assetCardIdArr: [],
        assetCardNoArr: [],
        assetCardInfos: [],
        supplierId: "",
        supplierName: "",
        manufacturerId: "",
        manufacturerName: "",

        warehouseName: "",
        warehouseId: "",
        warehouseManagerId: "",
        warehouseManagerName: "",
        deptId: "",
        deptName: "",
        amount: 0,
        fees: 0,
        inventoryNumber: 0,
        result: null,
        remark: null,
      };
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.details) {
        this.dataArray = [];
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    /**
     * 明细表删除
     */
    handleDeleteChildForm () {
      this.dataArray = this.dataArray.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.dataArray.forEach((e, index) => {
        e.$index = index + 1;
      });
      // this.autoTotalAmount();
      this.$emit("autoTotalAmount", this.dataArray);
    },
    /**
     * 子表选中行
     */
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    /**
     * 子表双击
     */
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      if (!this.childForm.assetCardInfos) {
        this.childForm.assetCardInfos = [];
      }
      this.$set(
        this.childForm,
        "assetCardIdArr",
        this.childForm.assetCardInfos?.map((e) => e.id)
      );
      this.$set(
        this.childForm,
        "assetCardNoArr",
        this.childForm.assetCardInfos?.map((e) => e.no)
      );
      this.getAssetCards("");
    },
    /**
     * 关闭子弹窗
     */
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    /**
     * 继续添加
     */
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    /**
     * 子弹框提交
     */
    submitChildForm () {
      this.pushChildForm(true);
    },
    /**
     * 保存
     */
    pushChildForm (close) {
      if (this.canEdit) {
        this.$refs["childForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.childForm.orgCode = sessionStorage.getItem('orgId')
          let isRepeat = false;
          if (this.isRepeatMethod) {
            isRepeat = this.isRepeatMethod(this.dataArray, this.childForm);
          }

          // this.capitalSourceChange()
          let item = this.dataArray.find(
            (e) => e.$index == this.childForm.$index
          );
          if (isRepeat && !this.editChildren) {
            // 新增且重复
            this.$my_message(this.isRepeatMsg, "error");
            return;
          } else if (isRepeat && this.editChildren) {
            // 是修改且重复
            this.$my_message(this.isRepeatMsg, "error");
            return;
          } else if (!isRepeat && this.editChildren) {
            // 修改且不重复
            Object.assign(item, this.childForm);
          } else {
            this.dataArray.push(this.childForm);
          }

          this.dataArray = [...this.dataArray];
          // this.autoTotalAmount();
          this.$emit("autoTotalAmount", this.dataArray);
          this.resetDetailFormData();
          if (close) {
            this.openSubformModal = false;
          }
        });
      } else {
        if (close) {
          this.openSubformModal = false;
        }
      }
    },
    childNumberChange () {
      if (this.childForm.maxAmount) {
        this.childForm.number =
          this.childForm.number > this.childForm.maxAmount
            ? this.childForm.maxAmount
            : this.childForm.number;
      }
      if (!this.isWorkOrder) {
        this.autoAmount();
      }
      this.childForm.notReceivedNumber = this.childForm.number;
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    cardChange (val) {
      if (this.assetCardMultiple) {
        if (val && val.length > 0) {
          let isAdd = false;
          // 判断是新增还是删除
          for (let i = 0; i < val.length; i++) {
            let item = this.childForm.assetCardInfos.find(
              (e) => e.no == val[i]
            );
            if (item == null) {
              isAdd = true;
              let obj = this.STATIC_AssetCards.find((e) => e.no == val[i]);
              if (obj) {
                this.childForm.assetCardInfos.push(obj);
              }
              break;
            }
          }
          // 删除
          if (!isAdd) {
            this.childForm.assetCardInfos = this.childForm.assetCardInfos.filter(
              (i) => val.indexOf(i.no) != -1
            );
          }
          this.childForm.assetCardIds = this.childForm.assetCardInfos
            .map((item) => item.id)
            .join(";");
        } else {
          this.childForm.assetCardIds = "";
          this.childForm.assetCardInfos = [];
        }
      } else {
        this.childForm.assetCardInfos = [];
        if (val) {
          let obj = this.STATIC_AssetCards.find((e) => e.no == val);
          if (obj) {
            this.childForm.assetCardInfos.push(obj);
            this.childForm.assetCardId = obj.id;
          }
          this.childForm.assetCardIds = this.childForm.assetCardInfos
            .map((item) => item.id)
            .join(";");
        }
      }
      this.childForm.maxNum = this.childForm.assetCardInfos.length;
      if (this.mustCard) {
        this.childForm.number = this.childForm.assetCardInfos.length;
      }
    },
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.childForm.warehouseId = item.id;
        this.childForm.warehouseManagerId = item.managerId;
        this.childForm.warehouseManagerName = item.managerName;
        this.childForm.isFictitious = item.isFictitious;
      }
    },
    deptChange (val) {
      this.childForm.deptId = val;
    },
    /**
     * 盘点数量选择
     */
    inventoryNumberChange (val) {
      this.childForm.diffNumber =
        this.childForm.inventoryNumber - this.childForm.number;
      this.childForm.diffAmount =
        this.childForm.diffNumber * this.childForm.price;
      if (this.childForm.number < val) {
        //盘盈
        this.childForm.result = "盘盈";
      } else if (this.childForm.number == val) {
        //正常
        this.childForm.result = "正常";
      } else {
        //盘亏
        this.childForm.result = "盘亏";
      }
    },
    /**
     * 资产编号选择
     */
    selectAsset (row) {
      if (this.selectAssetMethod) {
        this.selectAssetMethod(row).then((res) => {
          window.console.log(res);
        });
      } else {
        this.$emit("assetChange", row);
        if (this.isPurchase) {
          this.childForm = Object.assign(this.childForm, row, {
            // fixedAssetNo: row.no,
            // fixedAssetName: row.name,
            $index: this.childForm.$index,
            id: 0,
            assetCardIds: "",
            assetCardInfos: [],
            locationId: row.locationId,
            locationName: row.locationName,
            number: 1,
            stockNumber: row.number,
            maxAmount: row.number,
            price: 0,
            stockState: row.state,
          });
        } else if (this.isInventory) {
          this.childForm = Object.assign(this.childForm, row, {
            // fixedAssetNo: row.no,
            // fixedAssetName: row.name,
            $index: this.childForm.$index,
            id: 0,
            assetCardIds: "",
            assetCardInfos: [],
            locationId: row.locationId,
            locationName: row.locationName,
            stockState: row.state,
          });
        } else if (this.isWorkOrder) {
          this.childForm = Object.assign(this.childForm, row, {
            // fixedAssetNo: row.no,
            // fixedAssetName: row.name,
            $index: this.childForm.$index,
            id: 0,
            state: 1,
            assetCardIds: "",
            assetCardInfos: [],
            locationId: row.locationId,
            locationName: row.locationName,
            warehouseName: this.childForm.warehouseName,
            warehouseId: this.childForm.warehouseId,
            maxAmount: row.number,
            stockState: 1,
            number: 1,
            unBillNumber: 1,
            unBillAmount: row.price,
          });
        } else {
          this.childForm = Object.assign(this.childForm, row, {
            // fixedAssetNo: row.no,
            // fixedAssetName: row.name,
            $index: this.childForm.$index,
            id: 0,
            number: 1,
            assetCardIds: "",
            assetCardInfos: [],
            locationId: row.locationId,
            locationName: row.locationName,
            maxAmount: row.number,
            stockState: row.state,
          });
        }
        if (this.isMetering) {
          this.childForm.price = row.amount;
          this.childForm.fileInfos = [];
          this.childForm.state = 0;
        }
        var range = this.childForm.stockRange + "";
        if (range == "2" || !range) {
          this.childForm.warehouseId = row.warehouseId;
          this.childForm.stockDeptId = row.deptId;
        }
        this.getAssetCards("");
        this.childNumberChange();
      }
    },
    /**
     * 获取资产编号
     */
    getFixedAssetList (keyWord) {
      if (this.getFixedAssetListMethod) {
        return this.getFixedAssetListMethod(keyWord).then((res) => {
          if (this.isNoneAsset) {
            this.STATIC_NoneAssets = res;
          } else {
            this.STATIC_Stocks = res;
          }
        });
      } else {
        return this.getFixedAssetListSelf(keyWord);
      }
    },
    getFixedAssetListSelf (keyWord) {
      var param = Object.assign(this.FixedAssetParam, {
        keyWord: keyWord,
      });
      if (this.showDimension) {
        param = Object.assign(param, {
          deptId: this.childForm.stockDeptId,
          warehouseId: this.childForm.warehouseId,
          assetTypeId: this.childForm.fixedAssetTypeId,
        });
      }
      param.isFictitious = this.childForm.isFictitious;
      if (this.isNoneAsset) {
        return this.getNoneAssetsByQuerys(param);
      } else {
        return this.GetStocksContainDetailByQuery(param);
      }
    },
    /**
     * 获取资产卡号
     */
    getAssetCards (keyWord) {
      if (this.getAssetCardsMethod) {
        this.getAssetCardsMethod(keyWord).then((res) => {
          this.STATIC_AssetCards = res;
        });
      } else {
        this.getAssetCardsSelf(keyWord);
      }
    },
    getAssetCardsSelf (keyWord) {
      var param = Object.assign(this.AssetCardsParam, {
        keyWord: keyWord,
        states: [0, 1],
        stockDetailId: this.childForm.stockDetailId,
      });
      if (this.showDimension) {
        param = Object.assign(param, {
          deptId: this.childForm.stockDeptId,
          warehouseId: this.childForm.warehouseId,
        });
      }
      this.getAssetCardsByQuery(param).then((res) => {
        if (
          this.ParentForm.assetCardInfos &&
          this.ParentForm.assetCardInfos.length > 0
        ) {
          this.ParentForm.assetCardInfos.forEach((item) => {
            let o = this.STATIC_AssetCards.find((e) => e.id == item.id);
            if (!o) {
              this.STATIC_AssetCards.push(item);
            }
          });
        }
      });
    },
    /**
     */
    getDetails () {
      return this.dataArray;
    },
    /**
     */
    getDimensionParam () {
      return {
        deptId: this.childForm.stockDeptId,
        warehouseId: this.childForm.warehouseId,
        assetTypeId: this.childForm.fixedAssetTypeId,
      };
    },
    /**
     * 重置资产编号及附带信息
     */
    restAsset () {
      this.$set(this.childForm, "fixedAssetNo", null);
      this.$set(this.childForm, "fixedAssetName", null);
      this.$set(this.childForm, "assetCardNoArr", []);
      this.$set(this.childForm, "assetCardIds", null);
      this.$set(this.childForm, "assetCardIdArr", []);
      this.$set(this.childForm, "assetCardInfos", []);
      this.$set(this.childForm, "specName", null);
      this.$set(this.childForm, "unitName", null);
      this.$set(this.childForm, "brandName", null);
      this.$set(this.childForm, "manufacturerName", null);
      this.$set(this.childForm, "supplierName", null);
      this.$set(this.childForm, "assetTypeName", null);
      this.$set(this.childForm, "productionPlaceName", null);
      this.$set(this.childForm, "financeTypeName", null);
      this.$set(this.childForm, "price", undefined);
      this.$set(this.childForm, "locationName", null);
    },
    // 维度选择
    stocktakingRangeChange (val) {
      this.childForm.stockDeptId = null;
      this.childForm.stockDeptName = null;
      this.childForm.warehouseId = null;
      this.childForm.warehouseName = null;
      this.childForm.fixedAssetTypeId = null;
      this.childForm.fixedAssetTypeName = null;
      switch (val) {
        case 0:
          this.getDepts();
          break;
        case 1:
          this.getWarehouses();
          break;
        case 2:
          this.getAssetTrees();
          break;
      }
      this.restAsset();
      this.getFixedAssetList();
    },
    /**
     * 维度科室
     */
    wdDeptChange (val) {
      this.childForm.stockDeptId = val;
      this.restAsset();
      this.getFixedAssetList();
    },
    /**
     * 维度资产类型
     */
    wdAssetTypeChange (val) {
      if (val) {
        this.childForm.fixedAssetTypeId = val.id;
        this.childForm.fixedAssetTypeName = val.name;
      } else {
        this.childForm.fixedAssetTypeId = "";
        this.childForm.fixedAssetTypeName = "";
      }
      this.restAsset();
      this.getFixedAssetList();
    },
    /**
     * 维度库房
     */
    WdWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.childForm.warehouseId = item.id;
        this.childForm.warehouseManagerId = item.managerId;
        this.childForm.warehouseManagerName = item.managerName;
        this.childForm.isFictitious = item.isFictitious;
      } else {
        this.childForm.warehouseId = "";
        this.childForm.warehouseManagerId = "";
        this.childForm.warehouseManagerName = "";
        this.childForm.isFictitious = "";
      }
      this.restAsset();
      this.getFixedAssetList();
    },
    fileChange (e) {
      this.childForm.fileInfos = e;
    },
    privewImg (file) {
      // this.dialogImageUrl = file.path;
      // this.dialogVisible = true;
      this.dialogVisible = true;
      this.fileId = file.id;
      this.fileName = file.name;
    },
    closeImageViewer () {
      this.dialogVisible = false;
    },
    RemoveFile (file) {
      var index = this.fileInfos.indexOf(file);
      if (index > -1) {
        this.fileInfos.splice(index, 1);
      }
    },
    toDecimal4 (row, column, cellValue, index) {
      return "￥" + this.toDecimal(cellValue, 4);
    },
    toDecimal2 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 2);
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () { },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    if (this.isMetering) {
      this.stockColumns = this.stockColumns1;
    }
    if (this.isInventory) {
      this.childFormRules = this.childFormRules2;
    } else {
      this.childFormRules = this.childFormRules1;
    }
    this.dataArray = this.details;
    this.getWarehouses();
    this.getDepts();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.show-files {
  color: #286ab4;
  cursor: pointer;
}

.fileListUl_always {
  font-size: 12px;
  background-color: white;
  height: 30px;
  padding: 5px;
  border-radius: 5px;
  width: 350px;
  overflow: hidden;
  overflow-y: auto;
  transition: 0.5s;
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(40, 106, 180, 0.5);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track-piece {
    background: transparent;
  }
  .fileItem {
    display: flex;
    padding: 2px 0;
    width: 350px;
    list-style-type: none;
    cursor: default;
    text-align: center;
    .fileName {
      line-height: 17px;
      transition: 0.4s;
      display: -moz-inline-box; /* css注释：for ff2 */
      display: inline-block;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      border-bottom: 1px transparent solid;
      color: #c8c9cc;
      flex: 1;
    }
    .btn_group {
      line-height: 17px;
      width: 140px;
      span {
        transition: 0.4s;
        margin: 0 5px;
        cursor: pointer;
        color: rgba(40, 106, 180, 0.2);
      }
    }
  }
  .fileItem:hover {
    .fileName {
      transition: 0.4s;
      color: rgba(40, 106, 180, 0.5);
      border-bottom: 1px rgba(40, 106, 180, 0.5) solid;
    }
    .btn_group {
      span {
        transition: 0.4s;
        color: #286ab4;
      }
    }
  }
}
</style>
